// The Main Site Object
window.Site = {

    menu           : document.querySelector('.js-menu'),
    menuBtn        : document.querySelector('.js-menu-button'),
    schemeSwitcher : document.querySelectorAll('.scheme-button'),
    sections       : document.querySelectorAll('.content > div'),
    menuItems      : document.querySelectorAll('.menu-item'),

    // Init Function
    liftoff : () => {
        Site.toggleMenuOnButtonClick()
        Site.toggleColorScheme()
        Site.flipSiteOnLoad()
        Site.activateMenuitemWhenSectionIsInView()
        Site.closeMenuOnItemClick()
    },

    toggleMenuOnButtonClick : () => {
        Site.menuBtn.addEventListener('click' , () => {
            Site.showHideMenu()
        })
    },

    showHideMenu : () => {
        document.documentElement.classList.toggle('menu-is-open')
    },

    toggleColorScheme : () => {
        Site.schemeSwitcher.forEach(switcher => {
            switcher.addEventListener('click' , () => {

                // Switch the class on the body
                document.documentElement.classList.toggle('inverted');

                // Try grab the storage item
                if (localStorage.getItem("SiteIsInverted")) {
                    localStorage.removeItem("SiteIsInverted");
                } else {
                    localStorage.setItem("SiteIsInverted" , true);
                };

            })
        })
    },

    flipSiteOnLoad : () => {
        document.addEventListener('DOMContentLoaded' , () => {
            if (localStorage.getItem("SiteIsInverted")) {
                document.documentElement.classList.toggle('inverted');
            }
        })
    },

    activateMenuitemWhenSectionIsInView : () => {

        // The observer settings
        const observerSettings = {
            root       : null,
            rootMargin : "-30% 0% -60% 0%",
            threshold  : [0 , 1.0],
        };

        // The callback function
        const observerCallback = (entries, observer) => {
            entries.forEach((entry) => {

                if (entry.isIntersecting) {
                    document.getElementById(`link-${entry.target.id}`).classList.add('active')
                } else {
                    document.getElementById(`link-${entry.target.id}`).classList.remove('active')
                }

            });
        };

        // The observer itself
        const observer = new IntersectionObserver(observerCallback, observerSettings);

        Site.sections.forEach(section => {
            observer.observe(section)
        })

    },

    closeMenuOnItemClick : () => {
        Site.menuItems.forEach(menuItem => {
            menuItem.addEventListener('click' , (event) => {
                //event.preventDefault()
                //document.getElementById(menuItem.href).scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" })
                document.documentElement.classList.remove('menu-is-open')
            })
        })
    }

}

// Launch The Script
Site.liftoff()